import { MasterL10nMessages } from '@sm/question-ui/respondent-survey';
import { defineMessages } from '@sm/intl';

/**
 * Copy used by SMQuestions - re-declaring the messages here allows translation into the
 * 56 languages needed by RespWeb (as opposed to the 16 in SMQuestions)
 */

export const COPY: MasterL10nMessages = defineMessages({
  NPS_QUESTION_TITLE: {
    id: 'Nps.QUESTION_TITLE',
    defaultMessage:
      '<div class="{srOnlyClass}">On a scale of {minValue} to {maxValue}, </div>{heading}<div id="{instructionsId}" class="{srOnlyClass}"> {minValue} for {minLabelText}, {maxValue} for {maxLabelText}</div>',
    description: '[Type: header][Vis: high] - question title',
  },
  OK_LABEL: {
    id: 'Button.OK_LABEL',
    defaultMessage: 'OK',
    description: '[Type: button][Vis: high] - question ok label',
  },
  PREVIOUS_MONTH: {
    id: 'CalendarPicker.previousMonth',
    defaultMessage: 'Previous Month',
    description: '[Type: button][Vis: high] - button label to go to previous month',
  },
  NEXT_MONTH: {
    id: 'CalendarPicker.nextMonth',
    defaultMessage: 'Next Month',
    description: '[Type: button][Vis: high] - button label to go to next month',
  },
  MONTH_SELECT: {
    id: 'CalendarPicker.month',
    defaultMessage: 'Select a month',
    description: '[Type: label][Vis: high] - label for month selection combo box',
  },
  YEAR_SELECT: {
    id: 'CalendarPicker.year',
    defaultMessage: 'Select a year',
    description: '[Type: label][Vis: high] - label for year selection combo box',
  },
  MONTHS: {
    id: 'CalendarPicker.months',
    defaultMessage:
      '{months, select, January {January} February {February} March {March} April {April} May {May} June {June} July {July} August {August} September {September} October {October} November {November} December {December}}',
    description: '[Type: label][Vis: high] - label for the months',
  },
  DAY_OF_WEEK_LEGEND_SHORT: {
    id: 'Month.dayOfWeekLegendShort',
    defaultMessage: '{dayOfTheWeek, select, Mo {Mo} Tu {Tu} We {We} Th {Th} Fr {Fr} Sa {Sa} Su {Su}}',
    description: '[Type: label][Vis: high] - label for the day of the week in shorthand',
  },
  DAY_OF_WEEK_LEGEND_FULL: {
    id: 'Month.dayOfWeekLegendLong',
    defaultMessage:
      '{dayOfTheWeek, select, Mo {Monday} Tu {Tuesday} We {Wednesday} Th {Thursday} Fr {Friday} Sa {Saturday} Su {Sunday}}',
    description: '[Type: label][Vis: high] - label for the day of the week',
  },
  DAY_OF_MONTH: {
    id: 'Day.dayOfMonth',
    defaultMessage: '{dayInCalendar, date, full}',
    description: '[Type: label][Vis: high] - label for the full date',
  },
  DATE_LABEL: {
    id: 'DateInputWrapper.dateLabel',
    defaultMessage: 'Date',
    description: '[Type: label][Vis: high] - label for date input',
  },
  DATE_BUTTON_LABEL: {
    id: 'DateInputWrapper.dateButton',
    defaultMessage: 'Open calendar',
    description: '[Type: button][Vis: high] - aria text for opening the calendar picker',
  },
  US_DATE_FORMAT: {
    id: 'DateInputWrapper.dateFormatUs',
    defaultMessage: 'MM/DD/YYYY',
    description:
      '[Type: label][Vis: high] - ISO 8601 US date character format notation. No localized delimiter translation. Must be uppercase.',
  },
  INTL_DATE_FORMAT: {
    id: 'DateInputWrapper.dateFormatIntl',
    defaultMessage: 'DD/MM/YYYY',
    description: '[Type: label][Vis: high] - ISO 8601 International date character format notation. Must be uppercase.',
  },
  TIME_LABEL: {
    id: 'TimeInputWrapper.timeLabel',
    defaultMessage: 'Time',
    description: '[Type: label][Vis: high] - label for time input',
  },
  HOUR_LABEL: {
    id: 'TimeInputWrapper.hour',
    defaultMessage: 'Hour',
    description: '[Type: label][Vis: high] - label for hour input',
  },
  MINUTES_LABEL: {
    id: 'TimeInputWrapper.minutes',
    defaultMessage: 'Minutes',
    description: '[Type: label][Vis: high] - label for minutes input',
  },
  DAYTIME_LABEL: {
    id: 'TimeInputWrapper.daytimeLabel',
    defaultMessage: 'AM/PM',
    description: '[Type: label][Vis: high] - label for daytime AM/PM select',
  },
  AM: {
    id: 'TimeInputWrapper.am',
    defaultMessage: 'AM',
    description: '[Type: label][Vis: high] - label for ante meridiem',
  },
  PM: {
    id: 'TimeInputWrapper.pm',
    defaultMessage: 'PM',
    description: '[Type: label][Vis: high] - label for post meridiem',
  },
  HOUR_PLACEHOLDER: {
    id: 'TimeInputWrapper.hhPlaceholder',
    defaultMessage: 'hh',
    description: '[Type: placeholder][Vis: high] - placeholder text for hour input',
  },
  MINUTE_PLACEHOLDER: {
    id: 'TimeInputWrapper.mmPlaceholder',
    defaultMessage: 'mm',
    description: '[Type: placeholder][Vis: high] - placeholder text for minutes input',
  },
  DATE_INTL_FORMAT_ERROR: {
    id: 'DateTime.formatErrorDateIntl',
    defaultMessage: 'Please provide date in DD/MM/YYYY format.',
    description:
      '[Type: label][Vis: high] - label for incorrect or missing date error (using ISO 8601 US date character format notation)',
  },
  DATE_US_FORMAT_ERROR: {
    id: 'DateTime.formatErrorDateUs',
    defaultMessage: 'Please provide date in MM/DD/YYYY format.',
    description:
      '[Type: label][Vis: high] - label for incorrect or missing date error (using ISO 8601 international date character format notation)',
  },
  SELECT_AN_OPTION: {
    id: 'MatrixDropdown.EmptyTopNativeSelect',
    defaultMessage: 'Select an option',
    description: 'Label for screen readers when the top/default selection is empty',
  },
  ERROR_ENTER_HOURS: {
    id: 'DateTime.errorEnterHours',
    defaultMessage: 'Please enter hours from 0 to 12.',
    description: '[Type: label][Vis: high] - label for incorrect or missing hour input',
  },
  ERROR_ENTER_MINUTES: {
    id: 'DateTime.errorEnterMinutes',
    defaultMessage: 'Please enter minutes from 0 to 59.',
    description: '[Type: label][Vis: high] - label for incorrect or missing minute input',
  },
  ERROR_SELECT_PERIOD: {
    id: 'DateTime.errorSelectPeriod',
    defaultMessage: 'Please select AM/PM.',
    description: '[Type: label][Vis: high] - label for incorrect or missing period selection',
  },
  ARIA_RANK_MOVED_UP: {
    id: 'Ranking.AriaRankMovedUp',
    defaultMessage: '{label} moved up to number {position}',
    description: '[Type: button][Vis: high] - accessible ranking moved up label',
  },
  ARIA_RANK_MOVED_DOWN: {
    id: 'Ranking.AriaRankMovedDown',
    defaultMessage: '{label} moved down to number {position}',
    description: '[Type: button][Vis: high] - accessible ranking moved down label',
  },
  ARIA_RANK_MOVED_TO_TOP: {
    id: 'Ranking.AriaRankAtTop',
    defaultMessage: '{label} moved to the top of the list',
    description: '[Type: button][Vis: high] - accessible ranking at top of list',
  },
  ARIA_RANK_MOVED_TO_BOTTOM: {
    id: 'Ranking.AriaRankAtBottom',
    defaultMessage: '{label} moved to the bottom of the list',
    description: '[Type: button][Vis: high] - accessible ranking at bottom of list',
  },
  SLIDER_CLEAR_BUTTON_LABEL: {
    id: 'Slider.CLEAR_BUTTON_LABEL',
    defaultMessage: 'Clear',
    description: '[Type: label][Vis: low] - screen reader only label for clear button',
  },
  SLIDER_STEP_MESSAGE: {
    id: 'Slider.STEP_MESSAGE',
    defaultMessage: "We adjusted the number you entered based on the slider's scale.",
    description:
      '[Type: message][Vis: medium] - Message displayed when the entered value needs to be moved to the next closest step',
  },
  REQUIRED: {
    id: 'RespondentQuestionTitle.REQUIRED',
    defaultMessage: '(Required.)',
    description: '[Type: label][Vis: medium] - visualy hidden required text',
  },
  CHOOSE_OR_DRAG: {
    id: 'FileUpload.chooseDragFile',
    defaultMessage: '<div class={chooseClass}>Choose a file</div> <div class={dragClass}>or drag it here</div>',
    description: '[Type: label][Vis: high] - label for file input when a file has not been uploaded',
  },
  REPLACE_OR_DRAG: {
    id: 'FileUpload.replaceDragFile',
    defaultMessage: '<div class={chooseClass}>Replace file</div> <div class={dragClass}>or drag it here</div>',
    description: '[Type: label][Vis: high] - label for file input when a file has been uploaded',
  },
  SUPPORTED_FILES: {
    id: 'FileUpload.supportedFiles',
    defaultMessage: 'Supported Files',
    description: '[Type: label][Vis: high] - Prefix to the supported files list',
  },
  FILE_UPLOADING: {
    id: 'FileUpload.fileUploading',
    defaultMessage: 'File uploading',
    description: '[Type: label][Vis: high] - Label for when a file is uploading',
  },
  REMOVE_FILE: {
    id: 'FileUpload.removeFile',
    defaultMessage: 'Remove file',
    description: '[Type: label][Vis: high] - Label for the remove currently selected file button',
  },
  FILE_UPLOADED: {
    id: 'FileUpload.fileUploaded',
    defaultMessage: 'File uploaded successfully',
    description: '[Type: label][Vis: high] - Announcement message for when a file is uploaded successfully',
  },
  STAR: {
    id: 'StarRating.STAR',
    defaultMessage: '{count} {count, plural, one {star} other {stars}}',
    description: 'Star Symbol Rating Label',
  },
  SMILEY: {
    id: 'StarRating.Smiley',
    defaultMessage: '{count} {count, plural, one {smiley} other {smileys}}',
    description: 'Smiley Symbol Rating Label',
  },
  HEART: {
    id: 'StarRating.Heart',
    defaultMessage: '{count} {count, plural, one {heart} other {hearts}}',
    description: 'Heart Symbol Rating Label',
  },
  THUMB: {
    id: 'StarRating.Thumb',
    defaultMessage: '{count} {count, plural, one {thumb} other {thumbs}}',
    description: 'Thumb Symbol Rating Label',
  },
});

export default COPY;
